// import Vue from 'vue'

// Toast function
function toast({ title = "", message = "", type = "info", duration = 3000, img = "" }) {
  const main = document.getElementById("toast");
  if (main) {
    const toast = document.createElement("div");

    // Auto remove toast
    const autoRemoveId = setTimeout(function () {
      main.removeChild(toast);
    }, duration + 1000);

    // Remove toast when clicked
    toast.onclick = function (e) {
      // if (e.target.closest(".toast_close")) {
        main.removeChild(toast);
        clearTimeout(autoRemoveId);
      // }
    };

    const delay = (duration / 1000).toFixed(2);

    toast.classList.add("toaster", `toast-${type}`);
    toast.style.animation = `slideInLeft ease .3s, fadeOut linear 1s ${delay}s forwards`;

    toast.innerHTML = `
                    <div class="toast_icon">
                        <img src="${img}" />
                    </div>
                    <div class="toast_body">
                        <h3 class="toast_title">${title}</h3>
                        <p class="toast_msg">${message}</p>
                    </div>
                `;
    main.appendChild(toast);
  }
}

function isMobileOrTouch() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0 ||
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );
}

const convertChainIdToCoinType = (chainId) => {
  // L1 resolvers to addr
  if (chainId === 1) { // 1 is mainnet chain id
    return 'addr'
  }
  const cointype = (0x80000000 | chainId) >>> 0
  return cointype.toString(16).toLocaleUpperCase()
}
const convertReverseNodeToBytes = (address, chainId) => {
  const addressFormatted = address.toLowerCase()
  const addressNode = ethers.solidityPackedKeccak256(['string'], [addressFormatted.substring(2)]) // NOTE: hash it as a string not address
  const chainCoinType = convertChainIdToCoinType(chainId)
  const baseReverseNode = ethers.namehash(`${chainCoinType.toLocaleUpperCase()}.reverse`)
  const addressReverseNode = ethers.solidityPackedKeccak256(
    ['bytes32', 'bytes32'],
    [baseReverseNode, addressNode]
  )
  return addressReverseNode
}

function getHexFromRgb(r, g, b) {
  return ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2);
}

function getPixelsData(myImageData, width, height) {
  var pixels_arr = [];
  var p = 0;
  for(var i in myImageData) {
    if(i % 4 === 0) {
      pixels_arr[p] = {
        "r": myImageData[i]
      };
    } else if(i % 4 === 1) {
      pixels_arr[p]["g"] = myImageData[i];
    } else if(i % 4 === 2) {
      pixels_arr[p]["b"] = myImageData[i];
    } else if(i % 4 === 3) {
      pixels_arr[p]["a"] = myImageData[i];
      // log(pixels_arr[p]["a"])
      pixels_arr[p]["hex"] = getHexFromRgb(pixels_arr[p]["r"], pixels_arr[p]["g"], pixels_arr[p]["b"]);
      // if(p % canvas.width == 0) {
      //   log(pixels_arr[p])
      // }
      p++;
    }
  }
    
  let rows = []
  var ha = new Array(height / 16);
  var wa = new Array(width / 16);
  for(var hi = 0; hi < ha.length; hi++){ // for each vertical section
    let cols = [];
    for(var wi = 0; wi < wa.length; wi++){ // for each horizontal section
      cols.push([]);
    }
    rows.push(cols);
  }
  
  // rows is multidimension array to hold image data
  for(let row = 0; row < ha.length; row++){ // for each vertical section
    _.times(16, function(y){
      for(let col = 0; col < wa.length; col++){ // for each horizontal section
        _.times(16, function(x){
          rows[row][col].push(pixels_arr.shift());
        });
      }
    });
  }
  
  return rows;
}

function stringDataForEth(arr, url, bid, r, c, img_offset_x, img_offset_y) {
  const DATA_ENCODING_VERSION = 1;
  // for(var i in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //   for(var ii in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //     is.push(""+i+","+ii+"#0000ff");
  //   }
  // }
  // log('window offset', window.img_offset_x, window.img_offset_y);
  // log('STRING DATA FOR PIXEL DATA', arr, r, c, typeof r, typeof c)
  
  if(typeof r === 'string') {
    r = parseInt(r, 10);
  }
  if(typeof c === 'string') {
    c = parseInt(c, 10);
  }
  
  let colors = [];
  for(let i in arr) {
    let p = arr[i];
    colors.push(p['hex']);
  }
  let xOffset = ((img_offset_x / 16)+c);
  let yOffset = ((img_offset_y / 16)+r);
  // log('stringDataForEth', window.img_offset_x, window.img_offset_y, xOffset, yOffset, c, r);
  return "v"+DATA_ENCODING_VERSION+"|"+xOffset+","+yOffset+"|"+colors.join(',')+"|"+bid+"|"+encodeURIComponent(url);
}

const localStorage = {
  setItem: (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch(e) {
      console.error('Failed to set localstorage item', e);
    }
  },
  getItem: (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch(e) {
      console.error('Failed to get localstorage item', e);
    }
  },
  removeItem: (key) => {
    try {
      window.localStorage.removeItem(key);
    } catch(e) {
      console.error('Failed to remove localstorage item', e);
    }
  }
}

export default {
  localStorage,
  getHexFromRgb,
  getPixelsData,
  stringDataForEth,
  convertReverseNodeToBytes,
    truncateString: (str) => {
      return str.substring(0, 6) + '...' + str.substring(str.length - 4);
    },
    trackEvent(t, params = {}) {
      try {
        if (window.gtag) {
          gtag('event', t, params);
        }
      } catch(e) {
        console.error('Failed to track event', e);
      }
    },
    replaceTransparent: function(myImageData) {
      for (var i = 0, n = myImageData.length; i <n; i += 4) {
        // var r = myImageData[i],
        //     g = myImageData[i+1],
        //     b = myImageData[i+2],
        //     a = myImageData[i+3]
          
        // Completely transparent
        if(myImageData[i+3] === 0) {
          // Set to solid white
          myImageData[i] = 255;
          myImageData[i+1] = 255;
          myImageData[i+2] = 255;
          myImageData[i+3] = 255;
        }
      }
    },
    clearDraggableImage: function() {
      // Clear the draggable image from the page
      var uploadedImgCanvas = document.getElementById("uploadedImg");
      var uploadedImgCtx = uploadedImgCanvas.getContext("2d");
      uploadedImgCtx.clearRect(0, 0, uploadedImgCanvas.width, uploadedImgCanvas.height);
      uploadedImgCanvas.style.display = 'none';
    },
    confetti: function(partyTime) {
      
      const Confettiful = function(el) {
        document.querySelector('.confetti-wrapper').style.display = 'block';
        this.el = el;
        this.containerEl = null;
        
        this.confettiFrequency = 3;
        this.confettiColors = ['#ff0000', '#00ff00', '#0000ff', '#00ffff', '#ff00ff', '#ffff00'];
        this.confettiAnimations = ['slow', 'medium', 'fast'];
        
        this._setupElements();
        this._renderConfetti();
      };
      
      Confettiful.prototype._setupElements = function() {
        const containerEl = document.createElement('div');
        const elPosition = this.el.style.position;
        
        if (elPosition !== 'relative' || elPosition !== 'absolute') {
          this.el.style.position = 'relative';
        }
        
        containerEl.classList.add('confetti-container');
        
        this.el.appendChild(containerEl);
        
        this.containerEl = containerEl;
      };
      
      Confettiful.prototype._renderConfetti = function() {
        this.confettiInterval = setInterval(() => {
          const confettiEl = document.createElement('div');
          const confettiSize = (Math.floor(Math.random() * 3) + 12) + 'px';
          const confettiBackground = this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)];
          const confettiLeft = (Math.floor(Math.random() * this.el.offsetWidth)) + 'px';
          const confettiAnimation = this.confettiAnimations[Math.floor(Math.random() * this.confettiAnimations.length)];
          
          confettiEl.classList.add('confetti', 'confetti--animation-' + confettiAnimation);
          confettiEl.style.left = confettiLeft;
          confettiEl.style.width = confettiSize;
          confettiEl.style.height = confettiSize;
          confettiEl.style.backgroundColor = confettiBackground;
          
          confettiEl.removeTimeout = setTimeout(function() {
            confettiEl.parentNode.removeChild(confettiEl);
          }, 3000);
          
          this.containerEl.appendChild(confettiEl);
        }, 25);
      };
      Confettiful.prototype.stop = function() {
        // this.el.display = 'none';
        document.querySelector('.confetti-wrapper').style.display = 'none';
        clearInterval(this.confettiInterval);
      };
      
      window.confettiful = new Confettiful(document.querySelector('.js-container'));
      
      setTimeout(() => {
        window.confettiful.stop();
      }, partyTime);

    },
    toast: toast,
    isMobileOrTouch,
    wait: (ms) => new Promise(resolve => setTimeout(resolve, ms)),
}


// WEBPACK FOOTER //
// ./src/utils.js